import axios from "axios";

const api = axios.create({
  baseURL: "https://pos-backend-wqo9.onrender.com/api"
});

/**
 * =====================
 * REQUEST INTERCEPTOR
 * =====================
 * - Attach cashier token by default
 * - DO NOT override Authorization if already set
 */
api.interceptors.request.use((config) => {
  if (!config.headers.Authorization) {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

/**
 * =====================
 * RESPONSE INTERCEPTOR
 * =====================
 * - Logout ONLY when cashier token is invalid
 * - Do NOT logout on manager token failure
 */
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      const usedAuth = err.config?.headers?.Authorization || "";

      // If cashier token failed → logout
      if (usedAuth.includes(localStorage.getItem("token"))) {
        localStorage.removeItem("token");
        window.location.href = "/";
      }

      // If manager token failed → just remove manager token
      if (usedAuth.includes(localStorage.getItem("manager_token"))) {
        localStorage.removeItem("manager_token");
      }
    }

    return Promise.reject(err);
  }
);

/**
 * =====================
 * MANAGER API WRAPPER
 * =====================
 * - Explicitly inject manager token
 * - Overrides cashier token safely
 */
export const managerApi = {
  get: (url) =>
    api.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("manager_token")}`
      }
    }),

  post: (url, data = {}) =>
    api.post(url, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("manager_token")}`
      }
    })
};

export default api;
